import React, {useState} from 'react'
import BaseInput from "components/BaseInput";
import {isDeliverableMailbox} from "core/validation/mailbox";

// `label` is REQUIRED: an English default is a string that ships untranslated the moment a new
// call site forgets it (kitecorp/transferify-ui#334). Every caller passes `m.common.fields.*`.
export default function Email({error, onChange, label, ...other}) {
	return (<BaseInput
			error={error}
			onChange={onChange}
			label={label}
			type="email"
			{...other}
		/>
	)
};
export const useEmailValidation = () => {
	let [errorEmail, setErrorEmail] = useState(false);
	const checkEmail = (email) => {
		if (email === "") {
			setErrorEmail(false);
			return
		}
		if (validateEmail(email)) {
			setErrorEmail(false)
		} else {
			setErrorEmail(true)
		}
	};
	return [errorEmail, checkEmail];
};

// The mailbox grammar is the SERVER's — the SMTP transport every recipient reaches (ui#362). The old
// looser regex accepted quoted local parts, hyphen-leading domains and 65+ char locals the transport
// refuses, so those addresses only failed downstream as an opaque 400. `isDeliverableMailbox` is the
// single shared, React-free grammar in `core/validation/mailbox`; case is handled there, not here.
export function validateEmail(email) {
	return isDeliverableMailbox(String(email));
}
